export default (dc, { defaultModel, defaultView, ...config }) => {
  const type = 'slider-prev'
  const attrKey = config.attrSliderPrev
  const classKey = config.classSliderPrev

  dc.addType(type, {
    model: defaultModel.extend({
      defaults: {
        ...defaultModel.prototype.defaults,
        name: 'Slider Prev',
        draggable: false,
        droppable: false,
        copyable: false,
        removable: false,
        ...config.sliderPrevProps
      },

      init() {
        const attrs = this.getAttributes()
        attrs[attrKey] = 1
        this.setAttributes(attrs)
        classKey && this.addClass(classKey)
      }
    }, {
      isComponent(el) {
        if (el.hasAttribute && el.hasAttribute(attrKey)) {
          return { type }
        }
      }
    }),
    view: defaultView
  })
}
